<template>
        <div class="warp">
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="right">
                    <el-button 
					type="primary" 
          icon="el-icon-plus"
					size="small" 
					@click="edit()"
					v-if="authorities.indexOf('sys:permission:background:web:config:fund:institutions:button:add')!=-1"
					>添加</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="name"
                    show-overflow-tooltip
					v-if="authorities.indexOf('sys:permission:background:web:config:fund:institutions:button:sort')!=-1"
                    >
                    <template slot-scope="scope">
                        <div class="elrow">
                            <i class="el-icon-top" v-if="scope.$index != 0" @click="moveDown(scope.row,0)"></i>
                            <i class="el-icon-bottom" v-if="scope.$index != tableData.length - 1" @click="moveDown(scope.row,1)"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    show-overflow-tooltip
                    
                    label="排序">
                </el-table-column>
                <el-table-column
                    prop="mechanism"
                    show-overflow-tooltip
                    
                    label="机构名称">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    width="200"
                    label="LOGO">
                    <template slot-scope="scope">
                        <div class="tableName" @click="preview(scope.row)">{{scope.row.logo}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    
                    label="更新账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    label="更新时间">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:web:config:fund:institutions:button:view')!=-1 ||
                    authorities.indexOf('sys:permission:background:web:config:fund:institutions:button:edit')!=-1 ||
                    authorities.indexOf('sys:permission:background:web:config:fund:institutions:button:delete')!=-1"
                    label="操作"
                    
                    width="350">
                    <template slot-scope="scope">
                        <el-button 
						size="small" type="primary" class="super" plain
						 v-if="authorities.indexOf('sys:permission:background:web:config:fund:institutions:button:view')!=-1"
						@click="check(scope.row,i.permissionCode)"
						>查看</el-button>
                        <el-button size="small" type="primary" class="super" plain
						 v-if="authorities.indexOf('sys:permission:background:web:config:fund:institutions:button:edit')!=-1"
						@click="edit(scope.row)">编辑</el-button>
                        <el-button size="small" type="danger" class="super" plain
						 v-if="authorities.indexOf('sys:permission:background:web:config:fund:institutions:button:delete')!=-1"
						@click="del(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 弹出层 -->
            <!-- 合作机构明细 -->
            <el-dialog
                title="合作机构明细"
                :visible.sync="dialogInfo"
                width="50%">
                <div class="basic">
                    <div class="child">
                        <div class="name">机构名称：</div>
                        <div class="content">{{detailInfo.mechanism}}</div>
                    </div>
                    <div class="child">
                        <div class="name">LOGO：</div>
                        <div class="content">
                            <img style="max-width:100%" :src="detailInfo.frontPath+detailInfo.logo" alt="" srcset="">
                        </div>
                    </div>
                    <div class="child">
                        <div class="name">介绍：</div>
                        <div class="content">{{detailInfo.remarks}}</div>
                    </div>
                    <div class="child">
                        <div class="name">发布账号：</div>
                        <div class="content">{{detailInfo.createUserName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">发布时间：</div>
                        <div class="content">{{detailInfo.createTime}}</div>
                    </div>
                    <div class="child">
                        <div class="name">更新账号：</div>
                        <div class="content">{{detailInfo.modifyUserName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{detailInfo.updateTime}}</div>
                    </div>
                </div>
            </el-dialog>
            <!-- 添加编辑 -->
            <el-dialog
                :title="dialogEditTitle"
                :visible.sync="dialogEdit"
                width="30%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>机构名称：</div>
                        <el-input v-model="sendInfo.mechanism"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfo.mechanism']">错误提示：{{errors['sendInfo.mechanism']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>LOGO：</div>
                        <div class="content">
						<upLoad :action="'backstage/annex/file'"  
						@input="inputValue" :accept="'image/png,image/jpg,image/jpeg'" 
						:size="20" :value="sendInfo.logo"/></div>
                    </div>
                    <div class="hint">图片仅支持png、jpg，建议高宽比为1:1，尺寸建议200*200px，大小不超过20M</div>
                    <div class="error" v-if="errors['sendInfo.logo']">错误提示：{{errors['sendInfo.logo']}}</div>

                    <div class="childTextarea">
						<div class="name"><span>*</span>介绍：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfo.remarks" show-word-limit maxlength="500"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.remarks']">错误提示：{{errors['sendInfo.remarks']}}</div>

                    <div class="doubleBtn">
                        <el-button type="primary" @click="cancel">取消</el-button>
                        <el-button type="primary" @click="submit">确认</el-button>
                    </div>
                </div>
            </el-dialog>
             <!-- 预览弹出层 -->
            <el-dialog :visible.sync="dialogVisible" title="图片预览">
                <img style="max-width:100%" :src="logoUrl">
            </el-dialog>
        </div>
</template>

<script>
import upLoad from '../../../components/upLoad';
export default {
    components:{
        upLoad
    },
	props: ['iData','tab'],
    data(){
        return{
          loading:false,
          bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            tableData:[],//表格数据
            sendInfo:{
                id:'',
                mechanism:'',//机构名称
                logo:'',//logo
                remarks:'',//介绍
            },
            logoUrl:"",
            dialogInfo:false,//明细弹出层
            dialogEdit:false,//添加合作机构弹出层
            dialogVisible:false,
            dialogEditTitle:'',//添加弹出层名字
            detailInfo:{},
            moveUpDown:{
                id:'',
                move:''
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.mechanism':{
            test:function(){
                if(this.sendInfo.mechanism){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写介绍'
        },
        'sendInfo.logo':{
            test:function(){
                if(this.sendInfo.logo.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'上传LOGO图片'
        },
        'sendInfo.remarks':{
            test:function(){
                if(this.sendInfo.remarks){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写介绍'
        }
    },
    mounted(){
        const that= this
        that.getData()
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 75
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 75
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        inputValue(val){
            this.sendInfo.logo = val
        },
        preview(row){
            this.logoUrl = row.frontPath+ row.logo
            this.dialogVisible = true
        },
        getData(){
            this.loading = true
            this.$axiosc.get('backstage/fund/mechanism/list').then(res=>{
                this.loading = false
                if(res.code == 200){
                    this.tableData = res.data
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            }).catch(e=>{
              this.loading = false
            })
        },
        //上下移
        moveDown:function(row,val){
            this.moveUpDown.id = row.id
            this.moveUpDown.move = val
            this.$axiosc.get('backstage/fund/moveUpDown',{params:this.moveUpDown}).then(res=>{
                if(res.code == 200){
                    this.getData()
                    this.$message({
                        type: 'success',
                        message: val == 0?'上移成功!':'下移成功'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            })
        },
        //查看
        check:function(row,type){
			if(type=='sys:permission:background:web:config:fund:institutions:button:view'){
				this.$axiosc.get('backstage/fund/mechanism/details/'+row.id).then(res=>{
				    if(res.code ==  200){
				        this.detailInfo = res.data
				    }
				})
				this.dialogInfo=true;
			}else if(type=='sys:permission:background:web:config:fund:institutions:button:edit'){
				this.sendInfo.id = row.id
				this.sendInfo.mechanism = row.mechanism
				this.sendInfo.logo = row.logo
				this.sendInfo.remarks = row.remarks
				this.dialogEdit=true;
				this.dialogEditTitle='编辑合作机构';
			}else if(type=='sys:permission:background:web:config:fund:institutions:button:delete'){
				this.$confirm('是否删除？', '删除', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				    }).then(() => {
				        this.$axiosc.get('backstage/fund/delFundMechanism/'+row.id).then(res=>{
				            if(res.code == 200){
				                this.getData()
				                this.$message({
				                    type: 'success',
				                    message: '删除成功!'
				                });
				            }else{
				                this.$message({
				                    type: 'error',
				                    message: res.msg
				                });
				            }
				        })
				        
				}).catch(() => {});
			}
            
        },
        //编辑
        edit:function(row){
        //     setTimeout(() => {
        //         this.$vuerify.clear();
        //     }, 0);
        //     if(row){//编辑
        //         this.sendInfo.id = row.id
        //         this.sendInfo.mechanism = row.mechanism
        //         this.sendInfo.logo = row.logo
        //         this.sendInfo.remarks = row.remarks
        //         this.dialogEdit=true;
        //         this.dialogEditTitle='编辑合作机构';
        //     }else{ //发布
        //         this.sendInfo.id = ''
				// this.sendInfo.mechanism = ''
				// this.sendInfo.logo = ''
				// this.sendInfo.remarks = ''
        //         this.dialogEdit=true;
        //         this.dialogEditTitle='添加合作机构';
				// this.$vuerify.clear();
        //     }
          if(row) {
            window.localStorage.setItem('hzjg',JSON.stringify(row))
            this.$router.push({path:`/systemLayout/configuration/configurationSecond/edit/${row.id}`,params:{row}})
          }
          else {
            window.localStorage.removeItem('hzjg')
            this.$router.push({path:'/systemLayout/configuration/configurationSecond/edit'})
          }
        },
        //删除
        del:function(row){
            this.$confirm('是否删除？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axiosc.get('backstage/fund/delFundMechanism/'+row.id).then(res=>{
                        if(res.code == 200){
                            this.getData()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }else{
                            this.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                    
            }).catch(() => {});
        },
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axioscBody.post('backstage/fund/saveFundMechanism',this.sendInfo).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.dialogEdit = false
                        this.$message({
                            type: 'success',
                            message: this.sendInfo.id?'编辑成功!':'添加成功'
                        });
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        //取消
        cancel:function(){
            this.dialogEdit=false;
            this.sendInfo.name1='';
            this.sendInfo.name2=[];
            this.sendInfo.name3='';
            this.$vuerify.clear();
        }
    },
	watch:{
		dialogEdit:function(){
			if(!this.dialogEdit){
				// this.$vuerify.clear();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.warp{
    .retrieve{
        padding: 0;
        margin-bottom: 20px;
        .child{
            margin: 0;
        }
        .right{
            margin: 0;
        }
    }
}
</style>